$(document).ready(function () {
  if (document.body.clientWidth < 851) {
    $(".pro-feature-row-section .feature-row__item.layout_right").insertBefore(
      ".feature-row__item.feature-row__text--right"
    );
  } else {
    $(".pro-feature-row-section .feature-row__item.layout_right").insertAfter(
      ".feature-row__item.feature-row__text--right"
    );
  }

  if (document.body.clientWidth < 750) {
    $(".product_accrordion_wrapper").insertAfter(".product-single__meta");
  } else {
    $(".product_accrordion_wrapper").insertAfter(
      ".product-single__media-group .thumbnails-wrapper"
    );
  }

  if ($(window).width() < 991){
    $('.mobile-carousel .collection-list-grid ul').flickity({
      asNavFor: '.carousel-main',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      cellAlign: 'left'
    });
  }
  if ($(window).width() < 768){
  $('.about-columns-section .flexbox').flickity({
    contain: true,
    pageDots: true,
    prevNextButtons: false,
    cellAlign: 'left'
  });
}
var speed = $(".custom-banner-loop").attr('data-speed');
    $('.custom-banner-loop').flickity({
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      cellAlign: 'left',
      adaptiveHeight: true,
      autoPlay: true,
      autoPlay:  parseInt(speed), 
pauseAutoPlayOnHover: false,
      wrapAround: true
    });
});
